// Survey Overview stat tiles: Total Responses, Completion Rate, Total Contributors.
// Completion rate is computed inline from completionData fields.

import React from "react";
import { Typography } from "@material-tailwind/react";

export function OverviewSection({ totalResponses, completionData }) {
    return (
        <div className="mb-6">
            <Typography variant="h5" className="mb-1">
                Survey Overview
            </Typography>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-platinumlight p-4 rounded-lg">
                    <Typography className="font-semibold text-black">
                        Total Responses
                    </Typography>
                    <Typography className="text-black">
                        {totalResponses ?? "N/A"}
                    </Typography>
                </div>
                <div className="bg-platinumlight p-4 rounded-lg">
                    <Typography className="font-semibold text-black">
                        Completion Rate
                    </Typography>
                    <Typography className="text-black">
                        {completionData?.total_respondents > 0 ?
                            ((completionData.respondents_finished / completionData.total_respondents) * 100).toFixed(2) + "%" :
                            "0.00%"}
                    </Typography>
                </div>
                <div className="bg-platinumlight p-4 rounded-lg">
                    <Typography className="font-semibold text-black">
                        Total Contributors
                    </Typography>
                    <Typography className="text-black">
                        {completionData?.total_respondents || 0}
                    </Typography>
                </div>
            </div>
        </div>
    );
}
